import axios from "axios";

// const baseURL = "https://staggingfe.labridge.in/api/v1/";
// const baseURL = process.env.REACT_APP_BASE_BACKEND_API_URL
const baseURL = "https://lims.labridge.in/api/v1/";

const axiosInstance = axios.create({
  baseURL,
});

const AUTH_ERROR_EVENT = "app-auth-error";
let lastAuthErrorAt = 0;

// Set up request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      const now = Date.now();
      if (now - lastAuthErrorAt > 3000) {
        lastAuthErrorAt = now;
        window.dispatchEvent(
          new CustomEvent(AUTH_ERROR_EVENT, {
            detail: {
              status,
              message:
                status === 401
                  ? "Your session has expired. Please log out and log back in."
                  : "You are not authorized to perform this action. Please log out and log back in.",
            },
          })
        );
      }
    }

    return Promise.reject(error);
  }
);

if (localStorage.getItem("zone_id")) {
  axiosInstance.defaults.headers.common["x-custom-zone-id"] =
    localStorage.getItem("zone_id");
}
if (localStorage.getItem("franchise_id")) {
  axiosInstance.defaults.headers.common["x-custom-franchise-id"] =
    localStorage.getItem("franchise_id");
}
if (localStorage.getItem("is_super_franchise")) {
  axiosInstance.defaults.headers.common["x-custom-is-super-franchise"] =
    localStorage.getItem("is_super_franchise");
}
if (localStorage.getItem("is_franchise_employee")) {
  axiosInstance.defaults.headers.common["x-custom-is-franchise-employee"] =
    localStorage.getItem("is_franchise_employee");
}

export default axiosInstance;
export { AUTH_ERROR_EVENT };
